export default {
  computed: {
    toolsRoutes() {
      return {
        tools: {
          title: "Ferramentas"
        },
        "tools-webhook": {
          title: "Webhook (API e notificações)"
        },
        "tools-coproductions": {
          title: "Coproduções"
        },

        "tools-email-marketing": {
          title: "Email marketing"
        },

        "tools-automations": {
          title: "Automações"
        },

        "tools-invoices": {
          title: "Notas fiscais"
        },

        "tools-member-area": {
          title: "Área de membros"
        },

        "tools-mec-certifications": {
          title: "Certificações MEC"
        }
      };
    }
  }
};
